import CountUp from "react-countup";
import {CreditCard} from 'lucide-react';
import React, {useCallback, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Skeleton} from "antd";
import {APIv1} from "../../../api";
import './BaseNumberCardStyle.css'

const providers = [
    {key: 'payme', labelKey: 'common.providers.payme'},
    {key: 'click', labelKey: 'common.providers.click'},
    {key: 'uzum', labelKey: 'common.providers.uzum'},
    {key: 'anor', labelKey: 'common.providers.anor'},
];

const TransactionNumberCard = ({startPeriod, endPeriod, embedded = false}) => {
    const {t} = useTranslation();
    const [userData, setUserData] = useState({});
    const [fetchedData, setFetchedData] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const headers = {
                Authorization: `Token ${userData.token}`,
            };

            const providerData = await Promise.all(providers.map(async ({key}) => {
                const url = (startPeriod && endPeriod) ? `/analysis/transactions/counts/${key}/?start_period=${startPeriod}&end_period=${endPeriod}` : `/analysis/transactions/counts/${key}/`
                const response = await APIv1.get(url, {headers});
                const responseData = response.data;

                return {
                    key,
                    count: (responseData.success || 0) + (responseData.failure || 0),
                };
            }));

            setFetchedData(providerData);

        } catch (error) {
            console.error('Error fetching user data:', error);
        } finally {
            setLoading(false);
        }
    }, [userData.token, startPeriod, endPeriod]);

    useEffect(() => {
        if (!userData.token) return;

        fetchData()
    }, [userData.token, startPeriod, endPeriod])

    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('user'));
        if (items) {
            setUserData(items);
        }
    }, [userData.token]);

    const containerClassName = embedded
        ? "analysis__metrics__provider-section"
        : "analysis__metrics__card analysis__metrics__card-transaction__counts";

    return (
        <div className={containerClassName}>
            <h2>{t("analysis.numbersStats.mainTitles.transactionsCountsTitle")}</h2>
            <div className="analysis__metrics__container">
                {providers.map((provider) => {
                    const providerCount = fetchedData.find((item) => item.key === provider.key)?.count || 0;

                    return (
                        <div className={`analysis__metrics__card analysis__metrics__provider-card analysis__metrics__provider-card--${provider.key}`} key={provider.key}>
                            <span className="analysis__metrics__label">{t(provider.labelKey)}</span>
                            <div className="analysis__metrics__value analysis__metrics__provider-value">
                                <CreditCard className="analysis__metrics__icon"/>
                                {loading ? (
                                    <Skeleton.Button active style={{width: 54, height: 22}}/>
                                ) : (
                                    <CountUp end={providerCount} duration={2.5}/>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default TransactionNumberCard;
